import {FCWithHTMLAttributes} from "../../types/reactTypes";
import clsMerge from "../../util/clsMerge";

interface CircleProps {
	sizeClassName?: string;
}

const Circle: FCWithHTMLAttributes<CircleProps> = ({
	sizeClassName = "w-[27rem] h-[27rem]",
	className,
}) => {
	const classes = clsMerge(
		"rounded-full bg-gradient-to-r from-transparent to-light-green",
		sizeClassName,
		className
	);
	return <div className={classes} />;
};

export default Circle;
